require('./polyfills');
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { authenticateToken, loginUserSuccess } from './actions';
import Routes from './routes';
import ErrorBoundary from './components/ErrorBoundary';

require('./styles/style.scss');
/*
if (!React.PropTypes) {
  React.PropTypes = PropTypes;
  React.createClass = require('create-react-class');
}
  */
const MOUNT_NODE = document.getElementById('content');

export const history = createBrowserHistory();

const rootReducer = combineReducers({
  router: connectRouter(history),
  ...reducers
});

const middleware = applyMiddleware(thunk, routerMiddleware(history));

// Add a loading state to prevent rendering before auth check completes
let initialState = {};
const token = localStorage.getItem('token');

if (token !== null) {
  initialState = { auth: { token, authenticated: true, loading: true } };
}

const store = createStore(rootReducer, initialState, compose(middleware));

/* jwt token loading */
if (token !== null) {
  /* assume any existing token is valid, but check it immediately after */
  store.dispatch(loginUserSuccess(token));
}

/* hot module loading */
if (__DEV__ && module.hot) {
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers/index');
    store.replaceReducer(nextRootReducer);
  });
}

// If token exists, verify it before rendering
if (token) {
  store.dispatch(authenticateToken(token))
    .then(() => {
      renderApp();
    })
    .catch(() => {
      // Token invalid, remove it
      localStorage.removeItem('token');
      renderApp();
    });
} else {
  renderApp();
}

function renderApp() {
  try {
    ReactDOM.render(
      <Provider store={store}>
        <ErrorBoundary>
          <ConnectedRouter history={history}>
            <Routes />
          </ConnectedRouter>
        </ErrorBoundary>
      </Provider>,
      MOUNT_NODE
    );
  } catch (err) {
    console.error("Error during React rendering:", err);
  }
}
